// EmbedUtils.js
import EmbedsService from "@/embeds/embedService.js";
import AssignmentService from "@/assignments/assignmentsService.js";
// import embedService from "../../../../../embeds/embedService";

export default {
  IsCode(embed) {
    return (
      embed.StartLine &&
      embed.StartLine > 0 &&
      embed.EndLine &&
      embed.EndLine > 0
    );
  },
  GetIconForItem(embedNode) {
    var nodeTagsRaw = embedNode.data;
    if (nodeTagsRaw.RelatedTags) {
      var nodeTags = nodeTagsRaw.RelatedTags.map(itm => itm.Item);
      var typeTag = nodeTags.filter(t => t.TagType == 'EmbedType' || t.TagType == 'Section Type');
      if (typeTag && typeTag.length > 0) {
        for (var i = 0; i < typeTag.length; i++) {
          var tagToCheck = typeTag[i];
          switch (tagToCheck.TagSubType) {
            case "Objective":
              return 'icon-crosshair';
            case "KeyResult":
              return 'icon-flag';
            case "OKRQuarter":
              return 'icon-clock';
            case "OKRSection":
              return 'icon-compass';
            case "ProjectSection":
              return 'icon-home';
            case "ValuesSection":
              return 'icon-heart';
            case "CompanyValue":
              return 'icon-zap';
            case "Task":

              return 'icon-circle';
            default:
              return 'icon-book-open';
          }
        }

      }
    }
    return 'icon-book-open'
  },
  GetEmbedCode(embed) {
    if (
      !embed ||
      !embed.EmbedTypes ||
      embed.EmbedTypes.length == 0 ||
      embed.EmbedTypes[0] == null
    )
      return "icon-code";
    else {
      var embedTypeFirst = embed.EmbedTypes[0];
      switch (embedTypeFirst.toLowerCase()) {
        case "question":
          return "icon-flag";
        case "user documentation":
          return "icon-user";
      }
    }
  },

  SetEmbedStatistics() {

    var instance = this;
    var assignmentsDates = instance.InternalDetailsItem.AllAssignments;
    var owner = assignmentsDates.filter(
      (itm) => itm.AssignmentType == "Owner"
    );
    if (owner && owner.length > 0) {
      instance.$set(
        instance,
        "CurrentItemOwner",
        owner[owner.length - 1].CreatedForUserId
      );
    }

    var onboarded = assignmentsDates.filter(itm => itm.AssignmentType && (itm.AssignmentType.toLowerCase() == "correct assessment" || itm.AssignmentType.toLowerCase() == "onboarded over email"));
    var uniqueOnboarded = [];

    var onboarededAdded = {}

    for (var i = 0; i < onboarded.length; i++) {
      if (!onboarededAdded[onboarded[i].CreatedForUserId]) {
        uniqueOnboarded.push(onboarded[i]);
        onboarededAdded[onboarded[i].CreatedForUserId] = true;
      }
    }

    instance.$set(
      instance,
      "OnboardedPeople",
      uniqueOnboarded
    );

    for (var i = 0; i < onboarded.length - 1; i++) {
      if (!onboarededAdded[onboarded[i].CreatedForUserId]) {
        uniqueOnboarded.push(onboarded[i]);
        onboarededAdded[onboarded[i].CreatedForUserId] = true;
      }
    }

    instance.$set(
      instance,
      "OnboardedPeople",
      uniqueOnboarded
    );

    instance.$set(instance, "AssignmentData", assignmentsDates);
  },

  EmitEmbedClick(event) {
    var instance = this;
    if (event) {
      this.$set(this, "ContextMenuItem", event);

      instance.TopicsMenuVisible = false;

      EmbedsService.getItem(event.data.Id).then(function (response) {
        instance.$set(instance, "InternalDetailsItem", response.data);
        instance.$set(instance, "InDetails", true);
        instance.$set(instance, "EidShown", true);
        instance.$emit("EmbedOpened", response.data);
        instance.SetEmbedStatistics();

      });
    }
  },
  EditEmbed() {
    this.EmbedDetails();
    this.TopicsMenuVisible = false;
    this.$nextTick(function () {
      this.IsEditEmbedActive(true);
    });
  },
  DeleteEmbed() {
    var embed = this.ContextMenuItem.data;
    var instance = this;
    if (confirm("Are you sure you want to delete:\n" + embed.Title)) {
      EmbedsService.deleteBulk([embed]).then(function () {
        instance.ContextMenuItem.remove();
        instance.$refs.embedContextMenu.close();
      });
    }
  },
  PublishEmbed() {
    this.$set(this, "ShowPublishOptions", true);
  },
  AddEmbed(node) {
    var parent = null;
    if (this.ContextMenuItem) {
      parent = this.ContextMenuItem.data;
    }

    var projectIdCalculated = this.ProjectId;

    if (!this.ProjectId || this.ProjectId == 0) {
      if (parent) {
        projectIdCalculated = parent.ProjectId;
      }
    }

    if (!projectIdCalculated || this.ProjectId == 0) {
      throw "Could not get the Id of the project!";
    }

    this.$set(this, "InternalDetailsItem", {
      ProjectId: projectIdCalculated,
      RelativeFileName: "",
      StartLine: -1,
      StartColumn: -1,
      EndLine: -1,
      EndColumn: -1,
      CommitId: null,
      Branch: null,
      Title: "Your embed title",
      Description: "",
      RelatedTags: [],
      EmbedArea: parent == null ? "" : parent.EmbedFullArea,
    });

    this.$set(this, "InDetails", true);
    this.$set(this, "EditInternal", true);
  },
  AddCurrentUrlAsChildEmbed() {
    var parent = null;
    if (this.ContextMenuItem) {
      parent = this.ContextMenuItem.data;
    }

    var projectIdCalculated = this.ProjectId;

    if (!this.ProjectId || this.ProjectId == 0) {
      if (parent) {
        projectIdCalculated = parent.ProjectId;
      }
    }

    if (!projectIdCalculated || this.ProjectId == 0) {
      throw "Could not get the Id of the project!";
    }

    this.$set(this, "InternalDetailsItem", {
      ProjectId: projectIdCalculated,
      RelativeFileName: "",
      StartLine: -1,
      StartColumn: -1,
      EndLine: -1,
      EndColumn: -1,
      CommitId: null,
      Branch: null,
      Title: "Your embed title",
      Description: "",
      RelatedTags: [],
      EmbedArea: parent == null ? "" : parent.EmbedFullArea,
      Triggers: [{
        TriggerValue: this.TriggerUrl,
        TriggerType: 'exact',
      }]
    });

    this.$set(this, "InDetails", true);
    this.$set(this, "EditInternal", true);
  },
  Save(bClose) {
    this.$vs.loading({
      container: "#embeds-main-screen",
      scale: 0.6,
    });

    var instance = this;
    var isNew =
      !instance.InternalDetailsItem.Id ||
      instance.InternalDetailsItem.Id <= 0;

    delete instance.InternalDetailsItem.VersionHistory;

    EmbedsService.saveEmbed({
      Embed: instance.InternalDetailsItem,
      NotificationOptions: {
        EmailsToNotify: instance.EmailsToNotify,
        AllowEmbedNotifications: instance.AllowNotifyChecked,
      },
      Relations: null // TODO:instance.$refs.addEditEmbedWindow.GetSkillRelations(),
    })
      .then(function (response) {

        instance.$set(instance, "InternalDetailsItem", response.data);
        instance.$set(instance, "EditInternal", !bClose);

        if (instance.editParentNode != null && isNew) {
          instance.editParentNode.append({
            text: response.data.Title,
            children: response.data.Children,
            data: response.data,
          });

          instance.editParentNode.expand();
        }

        if (instance.ContextMenuItem && isNew) {
          instance.ContextMenuItem.append({
            text: response.data.Title,
            children: response.data.Children,
            data: response.data,
          });

          instance.ContextMenuItem.expand();
        }

        instance.$emit("EmbedUpdatedOrCreated", {
          isEdit: false,
          embed: response.data,
        });

        if (!bClose) {
          instance.$vs.notify({
            title: "Success",
            text: response.data.Title + " was saved successfully.",
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
          });
        }

        instance.$vs.loading.close("#embeds-main-screen > .con-vs-loading");
      })
      .catch(function (err) {
        var errMsg =
          err &&
            err.response &&
            err.response.data &&
            err.response.data.ExceptionMessage
            ? err.response.data.ExceptionMessage
            : err;
        instance.$emit("EmbedCrudProjectIdError", {
          isEdit: true,
          error: errMsg,
        });

        instance.$vs.loading.close("#embeds-main-screen > .con-vs-loading");
      });
  },
  IsEditEmbedActive(value) {
    this.$set(this, "EditInternal", value);
    if (!value) {
      this.$emit("EmbedEditExit", true);
    }
    return this.EditInternal;
  },
  async LoadEmbeds() {
    try {
      var isImmersive = this.Mode == "Immersive";

      if (!isImmersive) {
        this.$vs.loading({
          container: "#embeds-main-screen",
          scale: 1,
        });
      }

      var instance = this;
      var filter = "";

      if (this.ProjectId && this.ProjectId.length > 0) {
        filter = `ProjectId==${this.ProjectId}`;
      } else if (this.$route.query.projectId) {
        filter = `ProjectId==${this.$route.query.projectId}`;
      } else if (
        localStorage.getItem("projectContext") &&
        localStorage.getItem("projectContext").length > 0
      ) {
        try {
          filter = `ProjectId==${JSON.parse(localStorage.getItem("projectContext")).Id
            }`;
        } catch (err) {
          alert(
            "You may have invalid project focussed, pelase clear your local storage projectContext value."
          );
        }
      } else if (this.$route.query.eid) {
        var getItemResponse = await EmbedsService.getItem(
          this.$route.query.eid
        );

        var embedItem = getItemResponse.data;
        filter = `ProjectId==${embedItem.ProjectId}`;
      }

      if (instance.$route.query && instance.$route.query.aid) {
        if (isImmersive) {
          // Remove last / from the filter as it causes issues.
          var area = instance.$route.query.aid.toLowerCase();

          if (area[area.length - 1] == "/");
          area = area.substring(0, area.length - 1);

          filter +=
            ' && (EmbedArea + "/" + Slug).ToLower().StartsWith("' +
            area +
            '")';
        }
      }

      var flat = false;

      EmbedsService.getFilters(flat, true, false, filter, isImmersive).then(
        function (response) {
          instance.$set(instance, "embedFilters", response.data.EmbedTypes);
          instance.$set(instance, "IsLoading", false);
          if (
            instance.$route.query &&
            instance.$route.query.eid &&
            !instance.EidShown
          ) {
            EmbedsService.getItem(instance.$route.query.eid).then(function (
              response
            ) {
              instance.$set(instance, "InternalDetailsItem", response.data);
              instance.$set(instance, "InDetails", true);

              instance.SetEmbedStatistics();

              instance.$emit("EmbedOpened", response.data);
            });
          } else if (instance.$route.query && instance.$route.query.aid) {
            var pathToOpen = instance.$route.query.aid;
            instance.$nextTick(function () {
              instance.$set(instance, "embedSearchFilter", pathToOpen);
            });
          }

          if (!isImmersive) {
            instance.$vs.loading.close(
              "#embeds-main-screen > .con-vs-loading"
            );
          }
        }
      );
    } catch {
      if (!isImmersive) {
        this.$vs.loading.close("#embeds-main-screen > .con-vs-loading");
      }
      this.IsLoading = false;
    }
  },
  EmbedDetails(contextNode) {
    if (contextNode != null) {
      this.$set(this, "ContextMenuItem", contextNode);
    }

    this.EmitEmbedClick(this.ContextMenuItem);
    this.SetEmbedStatistics();
  },
  IsOkrSection(contextNode) {

  },
  GetEmbedStyle(node) {
    if (
      node &&
      node.data &&
      node.data.EmbedObject &&
      node.data.EmbedObject.AllAssignments
    ) {
      var state = this.GetCurrentUserState(node);
      if (state < 0) {
        return "";
      } else if (state > 0 && state < 3) {
        return "border-left: 3px solid orange";
      } else if (state == 3) {
        return "border-left: 3px solid green";
      }
    }
    return -1;
  },
  SetNextTopic(nodeToStartWith) {
    var instance = this;
    // Get the next topic in the chain to read:
    if (nodeToStartWith.children && nodeToStartWith.children.length > 0) {
      instance.$set(
        instance,
        "InternalDetailsSiblingNext",
        nodeToStartWith.children[0]
      );
    } else {
      var parentNode = nodeToStartWith.parent;
      var currentIdx = nodeToStartWith.index();
      if (parentNode.children.length > currentIdx + 1) {
        instance.$set(
          instance,
          "InternalDetailsSiblingNext",
          parentNode.children[currentIdx + 1]
        );
      } else {
        if (nodeToStartWith.parent.parent != null) {
          var currentParentIndex = parentNode.index();
          if (parentNode.parent.children.length > currentParentIndex + 1)
            instance.$set(
              instance,
              "InternalDetailsSiblingNext",
              parentNode.parent.children[currentParentIndex + 1]
            );
        }
      }
    }
  },
  SetPreviousTopic(nodeToStartWith) {
    var instance = this;
    // Get the next topic in the chain to read:
    var nodeIdx = nodeToStartWith.index();
    if (nodeIdx > 0) {
      instance.$set(
        instance,
        "InternalDetailsSiblingPrev",
        nodeToStartWith.parent.children[nodeIdx - 1]
      );
    } else {
      var parentNode = nodeToStartWith.parent;
      if (parentNode) {
        instance.$set(instance, "InternalDetailsSiblingPrev", parentNode);
      }
    }
  },
  setCurrentContextMenuItem(node) {
    this.$set(this, "ContextMenuItem", node);
  },
  EmbedDragStart(node) {
    this.$set(this, "currentDragnode", node);
    this.$set(this, "lastDragParent", node.parent);
    this.$set(this, "lastDragIndex", node.index());
  },
  EmbedDragFinish(nodeBeingDragged) {
    var instance = this;

    var newParent = nodeBeingDragged.parent?.data;

    var previousParent = null;
    if (this.lastDragParent) {
      previousParent = this.lastDragParent.data;
    }

    var oldIndex = this.lastDragIndex;
    var newIndex = nodeBeingDragged.index();

    EmbedsService.reorderEmbed({
      fromParent: previousParent == null ? "" : previousParent.EmbedFullArea,
      toParent: newParent == null ? "" : newParent.EmbedFullArea,
      oldIndex: oldIndex,
      newIndex: newIndex,
      nodeDraggedId: nodeBeingDragged.data.Id,
    }).then(
      function (response) {
        alert("Item was reordered.", response);
        instance.LoadEmbeds();
      },
      function (err) {
        var errMessage =
          err &&
            err.response &&
            err.response.data &&
            err.response.data.ExceptionMessage
            ? "\n" + err.response.data.ExceptionMessage
            : "";
        alert("Error!\n" + err + errMessage);
      }
    );
  },
}
